import cdLogo from "@images/CD_Logo.png";

export default function Header() {
  return (
    <header className="relative">
      <div className="flex h-(--mobile-navigation-height) w-full items-center bg-primary-bg lg:h-(--navigation-height)">
        <div className="ml-6 w-full sm:ml-[16%] lg:mx-auto lg:w-440 lg:pl-4">
          <img
            className="w-88 lg:w-lg"
            src={cdLogo}
            alt="Commerce Decisions logo"
          />
        </div>
      </div>
      <div className="bg-header-background bg-cover bg-center">
        <div className="flex h-[45vw] max-h-160 min-h-80 w-full flex-col justify-end bg-linear-to-tr from-primary-bg to-transparent">
          <h1 className="mb-4 ml-8 text-xl text-white sm:ml-[12%] md:text-2xl lg:mx-auto lg:w-440 lg:pl-6 lg:text-3xl">
            Return on Investment Calculator
          </h1>
        </div>
      </div>
    </header>
  );
}
